import {ProvidersAttributes} from '../Providers';
import React, {useEffect} from 'react';

import {environment} from '@shared/environment/environment';
import './Instamed.scss';
interface InstamedProps extends ProvidersAttributes {
  corporateId: string;
  accountId: string;
}
const Instamed = (props: InstamedProps): React.ReactElement => {
  const {corporateId, accountId, cardTokenized} = props;
  const [hide, setCardHidden] = React.useState(false);

  const callbackFromCardConnect = React.useCallback(
    (params: any): void => {
      let maskedCardNumber = '',
        temporaryToken = '',
        expDate = '';
      if ((params.Status && params.Status === 'Cancelled') || params.isError) {
        maskedCardNumber = '';
        temporaryToken = '';
        expDate = '';
      }
      if (params?.Token) {
        // @ts-ignore
        if (typeof window.InstaMed2.maskCardNumber === 'function') {
          // @ts-ignore
          maskedCardNumber = window.InstaMed2.maskCardNumber(params.Token);
        }
        expDate = params.ExpDate || '';
        temporaryToken = params.Token || '';
      }
      if (typeof cardTokenized === 'function') {
        cardTokenized({
          expiryDate: expDate,
          maskedCardNumber,
          temporaryToken,
          type: 'card'
        });
      }
    },
    [cardTokenized]
  );

  const callInstaMedAddCard = React.useCallback(() => {
    if (!corporateId || !accountId) {
      // TODO : REVERT THIS LINE
      setCardHidden(true);
      return;
    }
    // @ts-ignore
    if (window.InstaMed2 && typeof window.InstaMed2.addCard === 'function') {
      // @ts-ignore
      window.InstaMed2.addCard(
        callbackFromCardConnect,
        corporateId,
        environment.instamed.hostname,
        environment.instamed.manual,
        accountId
      );
    }
  }, [callbackFromCardConnect, accountId, corporateId]);

  useEffect(() => {
    setTimeout(() => {
      callInstaMedAddCard();
    }, 250);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (hide) {
    return <div>Cannot load instamed card details</div>;
  }
  return (
    <div className="instamed-container">
      <iframe id="instamed" className="payment-card-wrapper" />
    </div>
  );
};

export default Instamed;
